module.exports = __webpack_public_path__ + "static/img/8.3a76d0b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/sp/8.png
// module id = mwWD
// module chunks = 0